import validate from "/opt/atlassian/pipelines/agent/build/frontend/node_modules/nuxt/dist/pages/runtime/validate.js";
import route_45global from "/opt/atlassian/pipelines/agent/build/frontend/middleware/route.global.ts";
export const globalMiddleware = [
  validate,
  route_45global
]
export const namedMiddleware = {}